import { render } from "./AppModal.vue?vue&type=template&id=7b474424"
import script from "./AppModal.vue?vue&type=script&lang=js"
export * from "./AppModal.vue?vue&type=script&lang=js"

import "./AppModal.vue?vue&type=style&index=0&id=7b474424&lang=scss"
script.render = render

export default script